export default "__VITE_ASSET__DfyWj2gr__"